import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  assetLeaderboard: {
    id: 'assetLeaderboard',
    contentComponent: 'assetLeaderboard',
    title: 'Asset Leaderboard',
    params: { type: 'assetLeaderboard' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: { views: ['assetLeaderboard'], activeView: 'assetLeaderboard', id: 'assetLeaderboard' },
        size: 900,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.HORIZONTAL,
};

export const INTEL_LEADERBOARD_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
